/* eslint-disable react/sort-comp */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import EventListener from 'react-event-listener';
import RenderToLayer from 'material-ui/internal/RenderToLayer';
import propTypes from 'material-ui/utils/propTypes';
import Paper from 'material-ui/Paper';
import throttle from 'lodash.throttle';
import PopoverAnimationDefault from './PopoverAnimationDefault';
import Promise from 'bluebird';
const styles = {
  root: {
    display: 'none',
  },
};

/**
 * @deprecated we should switch to mui tooltip with react-popper arrow
 */
class PopoverWithArrow extends Component {
  static propTypes = {
    /**
     * This is the DOM element that will be used to set the position of the
     * popover.
     */
    anchorEl: PropTypes.object,
    /**
     * This is the point on the anchor where the popover's
     * `targetOrigin` will attach to.
     * Options:
     * vertical: [top, center, bottom]
     * horizontal: [left, middle, right].
     */
    anchorOrigin: propTypes.origin,
    /**
     * If true, the popover will apply transitions when
     * it is added to the DOM.
     */
    animated: PropTypes.bool,
    /**
     * Override the default animation component used.
     */
    animation: PropTypes.func,
    /**
     * If true, the popover will hide when the anchor is scrolled off the screen.
     */
    autoCloseWhenOffScreen: PropTypes.bool,
    /**
     * If true, the popover (potentially) ignores `targetOrigin`
     * and `anchorOrigin` to make itself fit on screen,
     * which is useful for mobile devices.
     */
    canAutoPosition: PropTypes.bool,
    /**
     * The content of the popover.
     */
    children: PropTypes.node,
    /**
     * The CSS class name of the root element.
     */
    className: PropTypes.string,
    /**
     * Callback function fired when the popover is requested to be closed.
     *
     * @param {string} reason The reason for the close request. Possibles values
     * are 'clickAway' and 'offScreen'.
     */
    onRequestClose: PropTypes.func,
    /**
     * If true, the popover is visible.
     */
    open: PropTypes.bool,
    /**
     * Override the inline-styles of the root element.
     */
    style: PropTypes.object,
    /**
     * This is the point on the popover which will attach to
     * the anchor's origin.
     * Options:
     * vertical: [top, center, bottom]
     * horizontal: [left, middle, right].
     */
    targetOrigin: propTypes.origin,
    /**
     * If true, the popover will render on top of an invisible
     * layer, which will prevent clicks to the underlying
     * elements, and trigger an `onRequestClose('clickAway')` call.
     */
    useLayerForClickAway: PropTypes.bool,
    /**
     * The zDepth of the popover.
     */
    zDepth: propTypes.zDepth,
    /**
     * used to calculate the bounding area that the popover should be contained in.
     */
    constrainTo: PropTypes.string,
    /**
     * Popover position offset to allow room for the arrow.
     */
    offset: PropTypes.number.isRequired,
  };

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired,
  };

  static defaultProps = {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    animated: true,
    autoCloseWhenOffScreen: true,
    canAutoPosition: true,
    onRequestClose: () => {},
    open: false,
    style: {
      overflowY: 'auto',
    },
    targetOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    useLayerForClickAway: true,
    zDepth: 1,
    offset: 20,
  };

  constructor(props, context) {
    super(props, context);
    this.handleResize = throttle(this.setPlacement, 100);
    this.handleScroll = throttle(this.setPlacement.bind(this, true), 50);

    this.state = {
      open: props.open,
      closing: false,
    };
  }

  componentWillMount() {
    this.mounted = true;
    const {constrainTo} = this.props;
    if (constrainTo) {
      if (constrainTo.top !== undefined) {
        this.constraintTop = constrainTo.top;
      } else {
        const constraintToEl = window.document.getElementById(constrainTo);
        if (constraintToEl) {
          this.constraintTop = constraintToEl.getBoundingClientRect().top;
        }
      }
    } else {
      this.constraintTop = 0;
    }
    this.constraintTop += 10;
  }

  componentDidMount() {
    this.setPlacement();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open === this.props.open) {
      return;
    }

    if (nextProps.open) {
      clearTimeout(this.timeout);
      this.timeout = null;
      this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
      this.setState({
        open: true,
        closing: false,
      });
    } else {
      if (nextProps.animated) {
        if (this.timeout !== null) return;
        this.setState({closing: true});
        this.timeout = setTimeout(() => {
          this.setState({
            open: false,
          }, () => {
            this.timeout = null;
          });
        }, 500);
      } else {
        this.setState({
          open: false,
        });
      }
    }
  }

  componentDidUpdate() {
    if (this.props.anchorEl) {
      this.setPlacement();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.handleResize.cancel();
    this.handleScroll.cancel();

    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  timeout = null;

  renderLayer = () => {
    const {
      animated,
      animation,
      anchorEl, // eslint-disable-line no-unused-vars
      anchorOrigin, // eslint-disable-line no-unused-vars
      autoCloseWhenOffScreen, // eslint-disable-line no-unused-vars
      canAutoPosition, // eslint-disable-line no-unused-vars
      children,
      onRequestClose, // eslint-disable-line no-unused-vars
      style,
      targetOrigin,
      offset,
      useLayerForClickAway, // eslint-disable-line no-unused-vars
      zDepth,
      ...other
    } = this.props;

    let styleRoot = style;

    const ARROW_BOX_SIZE = 22;
    const arrowOffsetLeft = animated ? (style.paddingLeft || style.padding || 0) + ARROW_BOX_SIZE : ARROW_BOX_SIZE;
    const arrowOffsetBottom = animated ? (style.paddingBottom || style.padding || 0) + ARROW_BOX_SIZE : ARROW_BOX_SIZE;
    const arrowStyles = {
      left: {
        arrowWrapper: {width: ARROW_BOX_SIZE, height: ARROW_BOX_SIZE, position: 'absolute', top: `50%`, left: -arrowOffsetLeft + 0.5, transform: 'translateY(-50%)', overflow: 'hidden'},
        arrow: {width: '50%', height: '50%', borderRadius: 0, transform: 'rotate(45deg)', top: '25%', left: '75%', backgroundColor: style.backgroundColor, position: 'relative'},
        root: {transform: `translateX(${offset}px)`},
      },
      bottom: {
        arrowWrapper: {width: ARROW_BOX_SIZE, height: ARROW_BOX_SIZE, position: 'absolute', left: `50%`, bottom: -arrowOffsetBottom + 0.5, transform: 'translateX(-50%)', overflow: 'hidden'},
        arrow: {width: '50%', height: '50%', borderRadius: 0, transform: 'rotate(45deg)', top: '-25%', left: '25%', backgroundColor: style.backgroundColor, position: 'relative'},
        root: {transform: `translateY(-${offset}px)`},
      },
      top: {
        arrowWrapper: {width: ARROW_BOX_SIZE, height: ARROW_BOX_SIZE, position: 'absolute', left: `50%`, top: -arrowOffsetBottom + 0.5, transform: 'translateX(-50%)', overflow: 'hidden'},
        arrow: {width: '50%', height: '50%', borderRadius: 0, transform: 'rotate(45deg)', bottom: '-75%', left: '25%', backgroundColor: style.backgroundColor, position: 'relative'},
        root: {transform: `translateY(+${offset}px)`},
      }
    };
    const arrowStyle = arrowStyles[targetOrigin.vertical] || arrowStyles[targetOrigin.horizontal];
    const arrow = (
      <div ref={ref => {if (ref) this.arrowRef = ref;}} style={arrowStyle.arrowWrapper}>
        <Paper zDepth={zDepth} style={arrowStyle.arrow}/>
      </div>
    );

    if (!animated) {
      styleRoot = {
        position: 'fixed',
        zIndex: this.context.muiTheme.zIndex.popover,
        opacity: 0,
      };

      if (!this.state.open) {
        return null;
      }

      return (
        <Paper transitionEnabled={false} style={Object.assign(styleRoot, style, arrowStyle.root)} {...other} zDepth={zDepth}>
          {children}
          {arrow}
        </Paper>
      );
    }

    const Animation = animation || PopoverAnimationDefault;

    return (
      <Animation
        targetOrigin={targetOrigin}
        style={{...styleRoot, ...arrowStyle.root}}
        {...other}
        open={this.state.open && !this.state.closing}
      >
        {arrow}
        {children}
      </Animation>
    );
  };

  requestClose(reason) {
    if (this.props.onRequestClose) {
      this.props.onRequestClose(reason);
    }
  }

  componentClickAway = (event) => {
    if (this.mounted) { // workaround for render to layer bug that keeps firing event after unmount.
      event.preventDefault();
      this.requestClose('clickAway');
    }
  };

  getAnchorPosition(el) {
    if (!el) {
      el = ReactDOM.findDOMNode(this);
    }
    if (!el.getBoundingClientRect) {
      el = ReactDOM.findDOMNode(el);
    }
    const rect = el.getBoundingClientRect();
    const a = {
      top: rect.top,
      left: rect.left,
      width: el.offsetWidth,
      height: el.offsetHeight,
    };

    a.right = rect.right || a.left + a.width;
    a.bottom = rect.bottom || a.top + a.height;
    a.middle = a.left + ((a.right - a.left) / 2);
    a.center = a.top + ((a.bottom - a.top) / 2);

    return a;
  }

  getTargetPosition(targetEl) {
    return {
      top: 0,
      center: targetEl.offsetHeight / 2,
      bottom: targetEl.offsetHeight,
      left: 0,
      middle: targetEl.offsetWidth / 2,
      right: targetEl.offsetWidth,
    };
  }

  setPlacement = async (scrolling) => {
    if (!this.state.open) {
      return;
    }

    if (!this.refs.layer.getLayer()) {
      return;
    }

    let targetEl = this.getTargetEl();
    if (!targetEl) {
      await Promise.delay(0);
      targetEl = this.getTargetEl();
      if (!targetEl) {
        return;
      }
    }

    const {targetOrigin, anchorOrigin} = this.props;
    const anchorEl = this.getAnchorEl();

    const anchor = this.getAnchorPosition(anchorEl);
    let target = this.getTargetPosition(targetEl);

    let targetPosition = {
      top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
      left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal],
    };

    if (scrolling && this.props.autoCloseWhenOffScreen) {
      this.autoCloseWhenOffScreen(anchor);
    }

    if (this.props.canAutoPosition) {
      target = this.getTargetPosition(targetEl); // update as height may have changed
      targetPosition = this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
    }

    targetEl.style.top = `${Math.max(0, targetPosition.top)}px`;
    targetEl.style.left = `${Math.max(0, targetPosition.left)}px`;
    targetEl.style.maxHeight = `${window.innerHeight}px`;
    targetEl.style.opacity = 1;
  };

  getAnchorEl() {
    return this.props.anchorEl || this.anchorEl;
  }

  getTargetEl() {
    return this.refs.layer.getLayer().children[0];
  }

  autoCloseWhenOffScreen(anchorPosition) {
    if (anchorPosition.top < 0 ||
      anchorPosition.top > window.innerHeight ||
      anchorPosition.left < 0 ||
      anchorPosition.left > window.innerWidth) {
      this.requestClose('offScreen');
    }
  }

  getOverlapMode(anchor, target, median) {
    if ([anchor, target].indexOf(median) >= 0) return 'auto';
    if (anchor === target) return 'inclusive';
    return 'exclusive';
  }

  getPositions(anchor, target) {
    const a = {...anchor};
    const t = {...target};

    const positions = {
      x: ['left', 'right'].filter((p) => p !== t.horizontal),
      y: ['top', 'bottom'].filter((p) => p !== t.vertical),
    };

    const overlap = {
      x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
      y: this.getOverlapMode(a.vertical, t.vertical, 'center'),
    };

    positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
    positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');

    if (overlap.y !== 'auto') {
      a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
      if (overlap.y === 'inclusive') {
        t.vertical = t.vertical;
      }
    }

    if (overlap.x !== 'auto') {
      a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
      if (overlap.y === 'inclusive') {
        t.horizontal = t.horizontal;
      }
    }

    return {
      positions: positions,
      anchorPos: a,
    };
  }

  applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
    const {positions, anchorPos} = this.getPositions(anchorOrigin, targetOrigin);
    const oldTop = targetPosition.top;
    const oldLeft = targetPosition.left;

    const arrowStyles = {
      left: {top: '50%'},
      bottom: {left: '50%'}
    };
    if (oldTop < this.constraintTop || oldTop + target.bottom > window.innerHeight) {
      let newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
      if (newTop + target.bottom <= window.innerHeight) {
        targetPosition.top = Math.max(this.constraintTop, newTop);
      } else {
        newTop = window.innerHeight - 10 - target.bottom;
        targetPosition.top = Math.max(this.constraintTop, newTop);
      }
      if (targetPosition.top > oldTop) {
        arrowStyles.left = {top: `calc(50% - ${(targetPosition.top - oldTop)}px)`};
      } else if (targetPosition.top < oldTop) {
        arrowStyles.left = {top: `calc(50% + ${(oldTop - targetPosition.top)}px)`};
      }
    }


    if (targetPosition.left < 20 || targetPosition.left + target.right > window.innerWidth - 20) {
      if (targetPosition.left < 20) {
        let newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
        if (newLeft + target.right <= window.innerWidth) {
          targetPosition.left = Math.max(20, newLeft);
        } else {
          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
          if (newLeft + target.right <= window.innerWidth) {
            targetPosition.left = Math.max(20, newLeft);
          }
        }
      } else {
        const newLeft = window.innerWidth - 20 - target.right;
        targetPosition.left = Math.max(20, newLeft);
      }
      if (targetPosition.left < oldLeft) {
        arrowStyles.bottom = {left: `calc(50% + ${(oldLeft - targetPosition.left)}px)`};
      }
    }

    const arrowEl = ReactDOM.findDOMNode(this.arrowRef);
    if (arrowEl) {
      const arrowStyle = arrowStyles[targetOrigin.vertical] || arrowStyles[targetOrigin.horizontal];
      if (arrowStyle) {
        Object.assign(arrowEl.style, arrowStyle);
      }
    }

    return targetPosition;
  }

  render() {
    return (
      <div style={styles.root}>
        <EventListener
          target="window"
          onScroll={this.handleScroll}
          onResize={this.handleResize}
        />
        <RenderToLayer
          ref="layer"
          open={this.state.open}
          componentClickAway={this.componentClickAway}
          useLayerForClickAway={this.props.useLayerForClickAway}
          render={this.renderLayer}
        />
      </div>
    );
  }
}

export default PopoverWithArrow;